import React, { useState, useEffect } from 'react';
import { Card } from 'reactstrap'
import swal from 'sweetalert';
import styled from 'styled-components'
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import api from "../../services/api"

const Wrapper = styled.div`
  padding: 10px;
`;
const TitleTag = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

const Title = styled.h5`
  font-size: 24px;
  font-weight: bold;
  color: #73777f;
`;

const GoBack = styled.div`
 margin-left: auto;
 cursor: pointer;
 text-transform: uppercase;
font-weight: bold;
color: #73777f;
`;


const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  @media (max-width: 768px) {
    flex-direction: column
  }
`;

const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 70vh;
  overflow: auto;
  padding: 20px;
`;

const SideContainer = styled.div`
  display: flex;
  width: 25%;
  border-left: 1px solid #4444;
  padding: 5px;
  color: #73777f;
  align-items: center;
  flex-direction: column;
  padding: 15px;
  @media (max-width: 768px) {
    width: 100%
  }
`;

const SideTitle = styled.h5`
  font-size: 24px;
  font-weight: bold;
  color: #73777f;
`;

const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 5px; 
`

const QuestionHeader = styled.div`
  display: flex;
  flex-direction: row;
  background-color: rgba(115, 119, 127, 0.08);
  padding: 5px;
  justify-content: flex-start;
`

const QuestionNumber = styled.h1`
  color: #73777f;
  font-size: 26px;
  font-weight: bold;
  margin-right: 15px;
  &::after{
    content: "."
  }
`
const QuestionTitle = styled.h5`
  color: #73777f;
  font-size: 16px;
  white-space: pre-line;
`
const QuestionAnswersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`

const QuestionAnswer = styled.div`
  font-weight: normal;
  width: 100%;
  margin: 10px;
  white-space: pre-line;
`

const QuestionComment = styled.div`
  width: 100%;
  margin: 10px;
  padding: 20px;
  border: 1px solid #ddd;
  background-color: rgba(115,119,127,0.08);
  color: #73777f;
  white-space: pre-line;
`

const Footer = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`

const NextQuestion = styled.div`
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;
  color: #73777f;
`

const PreviousQuestion = styled.div`
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;
  color: #73777f;
`

const QuestionJumperWrapper = styled.div`
 display: flex;
 flex-direction: row;
 width: 120px;
 flex-wrap: wrap;
`

const QuestionJumper = styled.div`
 display: flex;
 align-items: center;
 justify-content: center;
 background-color: ${props => props.color};
 width: 20px;
 height: 20px;
 color: #fff;
 margin: 1px 2px;
 border: ${props => props.active ? '1px solid #000' : 'unset'};
 cursor: pointer;
`

const QuestionResumeWrapper = styled.div`
 display: flex;
 flex-direction: column;
 margin-top: 5px;
 flex-wrap: wrap;
 width: 140px;
`

const QuestionResumeText = styled.div`
  font-size: 14px;
  font-weight: bold;
  text-align: center;
`

function LectureAnswers(props) {
  const [test, setTest] = useState({})
  const [currentQuestion, setCurrentQuestion] = useState(0)
  const [question, setQuestion] = useState({})
  const [gabarito, setGabarito] = useState({})
  const [ranking, setRanking] = useState([])
  const [currentPosition, setCurrentPosition] = useState({})
  useEffect(() => {
    api.get(`/getMockAnswer/${props.match.params.id}`).then(res => {
      setTest(res.mockAnswer.mockTest)
      setQuestion(res.mockAnswer.mockTest.questions[0])
      setGabarito(res.mockAnswer)
    })
  }, [props.match.params])

  useEffect(() => {
    if (test._id)
      api.get(`/mockAnswer/ranking/${test._id}`).then(res => {
        setRanking(res.ranking)
        setCurrentPosition(res.studentPosition)
      })
  },
    [test])

  const previousQuestion = () => {
    setCurrentQuestion(currentQuestion - 1);
    setQuestion(test.questions[currentQuestion - 1])
  }
  const nextQuestion = () => {
    setCurrentQuestion(currentQuestion + 1);
    setQuestion(test.questions[currentQuestion + 1])
  }
  const optionName = ["a", "b", "c", "d", "e"];

  const getRightWrongIcon = (rightAnswer, active) => {
    if (active || rightAnswer)
      return rightAnswer ? "✅" : "❌"
  }
  return (
    <Wrapper>
      <TitleTag>
        <Title>{test.title}</Title>
        <GoBack onClick={() => props.history.push(`/course/${props.match.params.courseId}/class/${props.match.params.classId}`)}>Voltar</GoBack>
      </TitleTag>
      <Card>
        <ContentWrapper>
          {test.questions && <QuestionsContainer>
            <QuestionWrapper>
              <QuestionHeader>
                <QuestionNumber>{currentQuestion + 1}</QuestionNumber>
                <QuestionTitle>
                  {question.text}
                </QuestionTitle>
              </QuestionHeader>
              <QuestionAnswersWrapper>
                {question.options && question.options.map((answer, index) => {
                  let color = '#73777f';
                  let active = false;
                  let rightAnswer = false;
                  if (gabarito.answers) {
                    if (gabarito.answers.length > 0) {
                      if (!gabarito.answers[currentQuestion])
                        color = '#ff4444'
                      else { active = gabarito.answers[currentQuestion].answer === index;
                        if (question.correctOption === index) {
                          color = '#00C851'
                          rightAnswer = true;
                        }
                        if (gabarito.answers[currentQuestion].answer !== question.correctOption && active) {
                          color = '#ff4444'
                        }
                      }
                    }
                  }
                  return <QuestionAnswer active={active} style={{ color }} key={`answer_${question._id}_${index}`}>
                    {getRightWrongIcon(rightAnswer, active)}
                    &nbsp;{optionName[index]})&nbsp;{answer}
                  </QuestionAnswer>
                })}
              </QuestionAnswersWrapper>
              {question.professorComment && <QuestionComment>
                {question.professorComment}
              </QuestionComment>}
            </QuestionWrapper>
            <Footer>
              {currentQuestion !== 0 && <PreviousQuestion onClick={() => previousQuestion()}>Anterior</PreviousQuestion>}
              {currentQuestion < (test.questions.length - 1) && <NextQuestion onClick={() => nextQuestion()} > Próxima</NextQuestion>}
            </Footer>
          </QuestionsContainer>}
          <SideContainer>
            <SideTitle>Ranking</SideTitle>
            {ranking.map((obj, index) =>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ marginRight: 5 }}>{index + 1}º)</div>
                <div style={{ maxWidth: "120px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{obj.nickname}</div>
                <div style={{ marginLeft: 5 }}>- {obj.correctCounter}</div>
              </div>
            )}

            <SideTitle style={{ marginTop: 30 }}>Resumo</SideTitle>
            {test.questions && <QuestionJumperWrapper>
              {test.questions.map((q, index) => {
                let color = ''
                if (gabarito.answers) {
                  color = '#ccc'
                  if (gabarito.answers.length > 0) {
                    if (gabarito.answers[index] && gabarito.answers[index].isCorrect)
                      color = '#00C851'
                    else
                      color = '#ff4444'
                  }
                }
                return <QuestionJumper onClick={() => { setCurrentQuestion(index); setQuestion(test.questions[index]) }} color={color} active={currentQuestion === index}>{index + 1}</QuestionJumper>
              })}
            </QuestionJumperWrapper>}
            <QuestionResumeWrapper>
              <QuestionResumeText>Status: {gabarito.isComplete ? 'Completo' : 'Incompleto'}</QuestionResumeText>
              {currentPosition && <QuestionResumeText>Sua posição: {currentPosition.position}</QuestionResumeText>}
              {test.questions && <QuestionResumeText>Acertos: {gabarito.correctCounter}/{test.questions.length}</QuestionResumeText>}
              {gabarito.timestamps && <QuestionResumeText>Finalizado em: {dayjs(gabarito.timestamps.updatedAt).format("DD/MM/YYYY HH:mm:ss")}</QuestionResumeText>}
            </QuestionResumeWrapper>
          </SideContainer>
        </ContentWrapper>
      </Card>
    </Wrapper >
  );
}

export default LectureAnswers;